import React from "react";
import "../../App.css";
import Cards from "../Cards";
import Cardsvideo from "../Cards.video";
import Cardsgallery from "../Cardsgallery";

function Photography() {
  return (
    <>
      <div className="photography"></div>
      <Cardsvideo />
      <Cards />
      <Cardsgallery/>
    </>
  );
}

export default Photography;
